import { useState } from "react";

import { useInboxEventsWebsocketContext } from "../context/InboxEventsWebsocketContext";

type LastSyncState = Record<
  string,
  {
    linkedIn: undefined | number;
    salesNav: undefined | number;
  }
>;

export default function useLastSync() {
  const [lastSyncState, setLastSyncState] = useState<LastSyncState>({});

  useInboxEventsWebsocketContext((data) => {
    if (data.type === "sync") {
      setLastSyncState((prevState) => ({
        ...prevState,
        [data.account_id]: {
          linkedIn: data.last_synced_at,
          salesNav: prevState[data.account_id]?.salesNav,
        },
      }));
    } else if (data.type === "sn_sync") {
      setLastSyncState((prevState) => ({
        ...prevState,
        [data.account_id]: {
          linkedIn: prevState[data.account_id]?.linkedIn,
          salesNav: data.last_synced_at,
        },
      }));
    }
  });

  return { lastSyncState };
}
